// @flow
import { tryTrack } from "../helpers"
import type { User } from "../../data/user/types"

const creditCardTrait = (u: User, desc: string) => ({
  email: u && u.email,
  description: desc,
})

export const trackCard = (
  eventName: "Card Rejected",
  u: User,
  desc: string,
  ) => tryTrack("Card Rejected", () => creditCardTrait(u, desc))



// WEBPACK FOOTER //
// ./src/analytics/creditCard/analyticsTraits.js